<main>
    <div class="d-flex h-100">
        <div id="main-sidebar" class="d-none d-md-block col-auto bg-blue-400 text-white" sidebar *ngIf="hasAuth && !hideSideBar"></div>
        <div id="main-body" class="col overflow-auto h-100">
            <router-outlet></router-outlet>
        </div>
    </div>
</main>